import { Component } from '@angular/core';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { CredentialType } from 'enums/CredentialType';
import { OrderModel } from 'models/generated/Entities.GormCrm.Order';
import { SelectListItemModel } from 'models/SelectList';
import { Layout } from 'modules/layout';
import { TeamPipe } from 'pipes/team.pipe';
import { TranslatePipe } from 'pipes/translate.pipe';
import { UserPipe } from 'pipes/user.pipe';
import { CredentialRequired } from 'services/credential.service';
import { ComponentUrl } from 'services/navigation.service';
import { UserService } from 'services/user.service';
import { ListOrdersComponent } from './orders/list-orders.component';

@Component({
	selector: 'list-orders-with-warnings',
	templateUrl: './list-orders-with-warnings.component.html',
	imports: [Layout, CustomSelectComponent, ListOrdersComponent, TranslatePipe]
})
@ComponentUrl('list-orders-with-warnings')
@CredentialRequired(CredentialType.ListOrdersWithCancellationWarnings)
export class ListOrdersWithWarningsComponent {

	public selectedTeamId?: string;
	public salesTeamList: SelectListItemModel[];
	constructor(private readonly team: TeamPipe, private readonly user: UserPipe, userService: UserService) {
		this.selectedTeamId = userService.getCurrentUser().defaultSalesTeamId;
		this.salesTeamList = userService.activeTeams.filter(t => t.sale).map(team => new SelectListItemModel(team.id!, team.name));
	}

	getSalesTeam = (order: OrderModel) => this.team.transform(order.salesTeamId);
	getSellerName = (order: OrderModel) => this.user.transform(order.sellerId, 'name');
	warningWasClosed = (order: OrderModel) => order.orderWarnings.filter(ow => !ow.closed).length == 0;
}
